import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DropDownModule } from '@shared/core/components/dropDown';
import { ButtonsModule } from '@shared/core/components/buttons';

import { SubNavDirectivesModule } from '../../directives';
import { SubNavForExpandedComponent } from './sub-nav-for-expanded.shared.component';

@NgModule({
    declarations: [
        SubNavForExpandedComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        DropDownModule,
        ButtonsModule,
        SubNavDirectivesModule,
    ],
    exports: [
        SubNavForExpandedComponent
    ],
})
export class SubNavForExpandedModule { }
